import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import "core-js/stable";
import "regenerator-runtime/runtime";

import {
  SET_INITIALIZE_APPLICATION,
  setInitializeSuccess,
  setInitializeFail,
} from "../action";

import util from "../../../global/utils/Helpers";
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/visa/"
  : `${util.getCurrentHost()}/auth/auth/visa/`;

let casePage = (application, application_id) => {
  return util.isLocalhost()
    ? `http://localhost:9393/dashboard/application/${application}/${application_id}`
    : `${util.getCurrentHost()}/dashboard/application/${application}/${application_id}`;
};

const fetchStateDataEpic = (action$) =>
  action$.pipe(
    ofType(SET_INITIALIZE_APPLICATION),
    mergeMap((action) =>
      fetch(apiIndex + action.payload.application, {
        credentials: "include",
        method: "POST",
        body: JSON.stringify({
          user_id: action.payload.user.subject,
          form_id: action.payload.application,
          case_assignee_id: action.payload.user.subject,
          group_id:
            action.payload &&
            action.payload.user.Group &&
            action.payload.user.Group.id
              ? action.payload.user.Group.id
              : null,
          data: {},
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Basic " +
            window.btoa(
              "flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"
            ),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          //console.log(data);
          setInitializeSuccess(data);
          window.location.assign(
            casePage(action.payload.application, data.payload.application_id)
          );
        })
        .catch((error) => {
          //console.log(action);
          setInitializeFail();
        })
    )
  );

export default fetchStateDataEpic;
